
(() => {
  const metric = (tool, choice) => {
    const payload = { event: 'vfw_intent_selected', vfw_tool: tool, vfw_choice: choice };
    if (Array.isArray(window.dataLayer)) window.dataLayer.push(payload);
    window.dispatchEvent(new CustomEvent('vfw:intent-selected', { detail: payload }));
  };

  // Wait for a complete subtree before enhancing controls; HTML remains usable until then.
  const initWhenReady = (host, attempt) => {
    if (attempt()) return;
    if (host._vfwInitObserver || typeof MutationObserver === 'undefined') return;
    host._vfwInitObserver = new MutationObserver(() => {
      if (attempt()) {
        host._vfwInitObserver.disconnect();
        host._vfwInitObserver = null;
      }
    });
    host._vfwInitObserver.observe(host, { childList: true, subtree: true });
  };

  class VfwSwitchboard extends HTMLElement {
    connectedCallback() {
      initWhenReady(this, () => {
        if (this.dataset.ready === 'true') return true;
      this.buttons = [...this.querySelectorAll('[data-vfw-choice]')];
      this.panels = [...this.querySelectorAll('[data-vfw-panel]')];
      if (!this.buttons.length || this.buttons.length !== this.panels.length) return false;
      this.dataset.ready = 'true';
      this.classList.add('is-enhanced');
      const initial = this.buttons.find((b) => b.classList.contains('is-active')) || this.buttons[0];
      this.buttons.forEach((button) => button.addEventListener('click', () => this.activate(button.dataset.vfwChoice, true)));
      this.activate(initial.dataset.vfwChoice, false);
      return true;
      });
    }
    disconnectedCallback() {
      if (this._vfwInitObserver) this._vfwInitObserver.disconnect();
      this._vfwInitObserver = null;
    }
    activate(key, track) {
      this.buttons.forEach((button) => {
        const on = button.dataset.vfwChoice === key;
        button.classList.toggle('is-active', on);
        button.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      this.panels.forEach((panel) => {
        const on = panel.dataset.vfwPanel === key;
        panel.hidden = !on;
        panel.classList.toggle('is-active', on);
      });
      if (track) metric(this.dataset.tool || 'switchboard', key);
    }
  }

  class VfwHallPlanner extends HTMLElement {
    connectedCallback() {
      initWhenReady(this, () => {
        if (this.dataset.ready === 'true') return true;
      const type = this.querySelector('[data-hall-type]');
      const size = this.querySelector('[data-hall-size]');
      const priority = this.querySelector('[data-hall-priority]');
      const output = this.querySelector('[data-hall-output]');
      if (!type || !size || !priority || !output) return false;
      const build = (track = false) => {
        const t = type.options[type.selectedIndex]?.text || 'Event';
        const s = size.options[size.selectedIndex]?.text || 'Guest count not selected';
        const p = priority.options[priority.selectedIndex]?.text || 'Priority not selected';
        output.textContent = `${t} • ${s} • priority: ${p}. Next: confirm live availability, approved capacity, rental rules, deposit, and pricing with Post 3175.`;
        if (track) metric('hall_fit_planner', `${type.value}|${size.value}|${priority.value}`);
      };
      [type,size,priority].forEach((el) => el.addEventListener('change', () => build(true)));
      this.dataset.ready = 'true';
      build(false);
      return true;
      });
    }
    disconnectedCallback() {
      if (this._vfwInitObserver) this._vfwInitObserver.disconnect();
      this._vfwInitObserver = null;
    }
  }

  class VfwBriefBuilder extends HTMLElement {
    connectedCallback() {
      initWhenReady(this, () => {
        if (this.dataset.ready === 'true') return true;
      const a = this.querySelector('[data-builder-a]');
      const b = this.querySelector('[data-builder-b]');
      const out = this.querySelector('[data-builder-output]');
      if (!a || !b || !out) return false;
      let routes = {};
      try { routes = JSON.parse(this.dataset.routes || '{}'); } catch (_) { routes = {}; }
      const build = (track = false) => {
        const av = a.value; const bv = b.value;
        const at = a.options[a.selectedIndex]?.text || av;
        const bt = b.options[b.selectedIndex]?.text || bv;
        const recommendation = routes[av] || routes.default || 'Start with one clearly scoped next step and confirm it with Post leadership.';
        out.textContent = `${at} • ${bt}. ${recommendation}`;
        if (track) metric(this.dataset.tool || 'brief_builder', `${av}|${bv}`);
      };
      [a,b].forEach((el) => el.addEventListener('change', () => build(true)));
      this.dataset.ready = 'true';
      build(false);
      return true;
      });
    }
    disconnectedCallback() {
      if (this._vfwInitObserver) this._vfwInitObserver.disconnect();
      this._vfwInitObserver = null;
    }
  }

  if (!customElements.get('vfw-switchboard')) customElements.define('vfw-switchboard', VfwSwitchboard);
  if (!customElements.get('vfw-hall-planner')) customElements.define('vfw-hall-planner', VfwHallPlanner);
  if (!customElements.get('vfw-brief-builder')) customElements.define('vfw-brief-builder', VfwBriefBuilder);

  document.addEventListener('shopify:block:select', (event) => {
    const block = event.target;
    const switchboard = block.closest('vfw-switchboard');
    if (!switchboard || typeof switchboard.activate !== 'function') return;
    const panel = block.matches('[data-vfw-panel]') ? block : block.querySelector('[data-vfw-panel]');
    const key = panel?.dataset.vfwPanel || block.dataset.vfwPanel || block.id;
    if (key) switchboard.activate(key, false);
  });
})();
